import { useEffect } from "react"
import { useNavigate } from "@tanstack/react-router"
import { JugglingScreen } from "@motley/design"
import { toast } from "sonner"
import { errorMessage } from "@/base"
import { useApplyVerifyEmailMutation } from "@/auth"

const DEFAULT_ERROR = "Email verification failed. Please try again."

type Props = {
  params: Record<string, string>
}

// The verification email links here: EmailVerifier rewrites its signed URL to /auth/verify/apply.
export default function ApplyVerifyEmail({ params }: Props) {
  const [applyVerifyEmail] = useApplyVerifyEmailMutation()
  const navigate = useNavigate()

  useEffect(() => {
    void (async () => {
      try {
        await applyVerifyEmail(params).unwrap()
        toast.success("Your email address has been verified.")
        await navigate({ to: "/", replace: true })
      } catch (e) {
        toast.error(errorMessage(e, DEFAULT_ERROR))
        await navigate({ to: "/auth/verify/request", replace: true })
      }
    })()
  }, [params, applyVerifyEmail, navigate])

  return <JugglingScreen />
}
